import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportQtyMismatchPage } from './report-qty-mismatch.page';

const routes: Routes = [
  {
    path: '',
    component: ReportQtyMismatchPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportQtyMismatchPageRoutingModule {}
